export default __webpack_public_path__ + "static/media/loss-overlay.5e7db4e8.png";